import React, { useState, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useStyles } from "../../../utils/useStyles";
import Heading from "../../Heading/Heading";
import Sidebar from "../../Super-Admin/Sidebar/Sidebar";

import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Api } from "../../../helper/ApiList";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { loaderAction } from "../../../services/actions/loaderAction";

import { useAlert, types } from "react-alert";
import useFetch from "../../../hooks/useFetch";
const EditMenus = () => {
  const classes = useStyles();
  const history = useHistory();
  const { token } = useSelector((state) => state.isStoreAdmin);
  const { singleMenu } = useSelector((state) => state.singleMenu);

  const { type } = useFetch(Api.showStoreAvailableServiceProfile, token, "get");

  const dispatch = useDispatch();

  const alert = useAlert();
  const [upload, setUpload] = useState(null);
  const [imagesPreview, setImagesPreview] = useState([]);
  const [category, setCategory] = useState([]);
  const [cateName, setCateName] = useState("");
  const [menuDetails, setMenuDetails] = useState({
    title: "",
    description: "",
    upc: "",
    skuCode: "",
    categoryIds: "",
    variants: [
      {
        productPackage: "",
        productPackageUnit: "",
        price: "",
        finalPrice: "",
        quantity: "",
        sizeSku: "",
        sizeUpc: "",
      },
    ],
  });

  const createCategoryImagesChange = (e) => {
    const files = Array.from(e.target.files);

    setImagesPreview([]);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState === 2) {
          setImagesPreview((old) => [...old, reader.result]);
        }
      };

      reader.readAsDataURL(file);
    });
    handleMenuImage(e);
  };

  React.useEffect(() => {
    const fetchAgain = async () => {
      await axios({
        method: "post",
        headers: { Authorization: `${token}` },
        url: Api.getCategoriesList,
      })
        .then((res) => {
          const { data } = res;

          if (data.response) {
            const { status, result } = data.response;

            if (status.statusCode === 200) {
              setCategory(result);
            }
          }
        })
        .catch((err) => {});
    };
    fetchAgain();
  }, [token]);

  const handleForm = (e) => {
    const { name, value } = e.target;

    let data = { ...menuDetails };

    if ("categoryIds" === name) {
      data[name] = [value];
    } else if (
      "productPackage" === name ||
      "productPackageUnit" === name ||
      "price" === name ||
      "finalPrice" === name ||
      "quantity" === name ||
      "sizeUpc" === name ||
      "sizeSku" === name
    ) {
      data.variants[name] = value;
    } else {
      data[name] = value;
    }
    setMenuDetails(data);
  };

  const handleMenuImage = async (e) => {
    dispatch(loaderAction(true));

    const file = e.target.files;
    const fileData = file === null ? null : file[0];

    var myForm = new FormData();
    myForm.append("name", fileData);

    myForm.append("file", fileData);

    const { data } = await axios({
      url: `${Api.fileUpload}`,
      method: "post",
      data: myForm,
    });
    if (data.status === 1) {
      setUpload(data.data);
      alert.success(data.message);
    } else {
      alert.info(data.message);
    }

    dispatch(loaderAction(false));
  };

  const handleSubmit = async () => {
    let inputData = menuDetails;
    inputData["image"] = upload;
    inputData["product_id"] = singleMenu?._id;

    if (upload) {
      dispatch(loaderAction(true));
      let config = {
        headers: { Authorization: `${token}` },
      };

      try {
        const { data } = await axios.put(Api.editProduct, inputData, config);

        const { response } = data;
        if (response.status.statusCode === 200) {
          alert.success("Menu has been updated successfully.");
          history.push("/Menu");
        } else {
          alert.info(response.status.customMessage);
        }
        dispatch(loaderAction(false));
      } catch (error) {
        const { response } = error;

        alert.error(response.data.message);
        dispatch(loaderAction(false));
      }
    } else {
      alert.info("Please upload the image");
    }
  };

  useEffect(() => {
    if (singleMenu) {
      let data = { ...menuDetails };

      // data["serviceType"] = singleMenu?.serviceId?.name;
      data["title"] = singleMenu?.title;
      data["description"] = singleMenu?.description;
      data["upc"] = singleMenu?.upc;
      data["skuCode"] = singleMenu?.skuCode;
      data["categoryIds"] = [singleMenu?.categoryIds[0]._id];
      setCateName(singleMenu?.categoryIds[0].name);
      data["variants"][0]["productPackage"] =
        singleMenu?.variants[0].productPackage;

      data["variants"][0]["productPackageUnit"] =
        singleMenu?.variants[0].productPackageUnit;

      data["variants"][0]["price"] = singleMenu?.variants[0].price;

      data["variants"][0]["finalPrice"] = singleMenu?.variants[0].finalPrice;
      data["variants"][0]["quantity"] = singleMenu?.variants[0].quantity;

      data["variants"][0]["sizeSku"] = singleMenu?.variants[0].sizeSku;

      data["variants"][0]["sizeUpc"] = singleMenu?.variants[0].sizeUpc;
      setUpload(singleMenu?.image);

      setMenuDetails(data);
    }
  }, [singleMenu]);

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Heading />

        <div className="mt-5">
          <Container>
            <Row>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="title"
                    placeholder="Product Name"
                    value={menuDetails.title}
                  />
                </Form.Group>
              </Col>
              {/* <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Service types</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="serviceType"
                    onChange={(e) => handleForm(e)}
                  >
                    {menuDetails.serviceType == "" ? (
                      <>
                        <option></option>
                        {type && (
                          <option value={type.toLowerCase()}>{type}</option>
                        )}
                      </>
                    ) : (
                      <option value={menuDetails.serviceType}>
                        {menuDetails.serviceType}
                      </option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col> */}
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Category Name</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="categoryIds"
                    onChange={(e) => handleForm(e)}
                  >
                    {menuDetails.categoryIds == "" ? (
                      <>
                        <option>Open this select menu</option>
                        {category && category.length > 0 ? (
                          category &&
                          category.map((cat, index) => (
                            <option value={cat._id} key={index}>
                              {cat.name}
                            </option>
                          ))
                        ) : (
                          <option>Not found</option>
                        )}
                      </>
                    ) : (
                      <option value={menuDetails.categoryIds}>
                        {" "}
                        {cateName}
                      </option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Product Package</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="productPackage"
                    placeholder="100gm"
                    defaultValue={menuDetails.variants[0].productPackage}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Product Package Unit</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="productPackageUnit"
                    onChange={(e) => handleForm(e)}
                  >
                    {menuDetails.variants[0].productPackageUnit == "" ? (
                      <>
                        <option>Open this Product Package Unit</option>
                        <option value="gm">gm</option>
                        <option value="kg">kg</option>
                      </>
                    ) : (
                      <option
                        value={menuDetails.variants[0].productPackageUnit}
                      >
                        {menuDetails.variants[0].productPackageUnit}
                      </option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="price"
                    placeholder="$15.00"
                    value={menuDetails.variants[0].price}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Final Price</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="finalPrice"
                    placeholder="$15.00"
                    value={menuDetails.variants[0].finalPrice}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Quantity</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="quantity"
                    placeholder="1"
                    value={menuDetails.variants[0].quantity}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Sku Code</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="skuCode"
                    placeholder="Sku Code"
                    value={menuDetails.skuCode}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Size Upc</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="sizeUpc"
                    placeholder="Size Upc"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={menuDetails.variants[0].sizeUpc}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              {/* <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Upc</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleForm(e)}
                    name="upc"
                    placeholder="Upc"
                    // onKeyPress={(event) => {
                    //   if (!/[0-9]/.test(event.key)) {
                    //     event.preventDefault();
                    //   }
                    // }}
                    value={menuDetails.upc}
                  />
                </Form.Group>
              </Col> */}
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    onChange={(e) => handleForm(e)}
                    placeholder="Lorem ipsum"
                    name="description"
                    value={menuDetails.description}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Container>

          <Container>
            <p className="ml-4">Upload Image</p>
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              id="contained-button-file"
              onChange={createCategoryImagesChange}
            />
            <div className="file">
              <label htmlFor="contained-button-file" className="file_upload">
                {upload ? (
                  <img
                    src={process.env.REACT_APP_IMAGE_URL + upload}
                    className="max-w-100 img_preview"
                    alt=""
                  />
                ) : (
                  <CollectionsOutlinedIcon className="upload_image" />
                )}
              </label>
            </div>
          </Container>
          <div className="div" style={{ float: "right" }}>
            <Button onClick={() => history.push("/menu")} className="cancel">
              Cancel
            </Button>
            <Button className="submit" onClick={() => handleSubmit()}>
              Submit
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditMenus;
